var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentDispensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_460033)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8915 11.4783C19.963 10.9959 20 10.5023 20 10C20 8.57779 19.7031 7.22492 19.1679 6H24V11.4783H19.8915ZM18.5217 15.2353C19.0795 14.3294 19.4968 13.3278 19.7434 12.2609H24V17.7391H18.5217V15.2353ZM16.3334 17.7391C16.8471 17.3182 17.3182 16.8471 17.7391 16.3334V17.7391H16.3334ZM12.2609 19.7434C13.3278 19.4968 14.3294 19.0795 15.2353 18.5217H17.7391V24H12.2609V19.7434ZM6 19.1679C7.22492 19.7031 8.57779 20 10 20C10.5023 20 10.9959 19.963 11.4783 19.8915V24H6V19.1679ZM24 18.5217H18.5217V24H24V18.5217Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white",
    stroke: "#0047A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92015 3L5.07628 8.23643L5.07795 8.23782C4.40342 9.03448 4 10.0454 4 11.1456C4 13.7162 6.20283 15.8002 8.92016 15.8002C11.6375 15.8002 13.8403 13.7162 13.8403 11.1456C13.8403 10.0454 13.4369 9.03448 12.7624 8.23782L12.764 8.23643L8.92015 3Z",
    fill: "#0047A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92016 3L4.8969 8.23643L4.89829 8.23782C4.33619 9.03448 4 10.0454 4 11.1456C4 14.2943 6.65572 15.8002 8.92016 15.8002C8.92016 15.8002 5.36671 13.837 5.36671 11.1779C5.36671 7.97784 8.92016 3 8.92016 3Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.032 11.6028L14.4944 13.847L14.4951 13.8476C14.2253 14.189 14.0639 14.6223 14.0639 15.0937C14.0639 16.1954 14.945 17.0886 16.032 17.0886C17.1189 17.0886 18 16.1954 18 15.0937C18 14.6223 17.8387 14.189 17.5688 13.8476L17.5695 13.847L16.032 11.6028Z",
    fill: "#0047A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.032 11.6028L14.4944 13.847L14.4951 13.8476C14.2253 14.189 14.0639 14.6223 14.0639 15.0937C14.0639 16.1954 14.945 17.0886 16.032 17.0886C16.032 17.0886 14.7199 16.2472 14.7199 15.1076C14.7199 13.7361 16.032 11.6028 16.032 11.6028Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6328 15.3428L11.864 16.8389L11.8643 16.8393C11.7294 17.0669 11.6487 17.3558 11.6487 17.6701C11.6487 18.4046 12.0893 19 12.6328 19C13.1762 19 13.6168 18.4046 13.6168 17.6701C13.6168 17.3558 13.5361 17.0669 13.4012 16.8393L13.4015 16.8389L12.6328 15.3428Z",
    fill: "#0047A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6328 15.3428L11.864 16.8389L11.8643 16.8393C11.7294 17.0669 11.6487 17.3558 11.6487 17.6701C11.6487 18.4046 12.0893 19 12.6328 19C12.6328 19 11.9768 18.4391 11.9768 17.6793C11.9768 16.765 12.6328 15.3428 12.6328 15.3428Z",
    fill: "#006AF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_460033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentDispensed);
export default __webpack_public_path__ + "static/media/Experiment_Dispensed.524d8668747e29067350a58b542efa16.svg";
export { ForwardRef as ReactComponent };